import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// The design system, imported rather than copied. Order matters: faces declares
// the families before tokens name them, tokens define the custom properties
// everything below reads, base sets the type roles, and components build on
// both. app.css adds screen composition and nothing visual.
import "../../design/css/reset.css";
import "../../design/fonts/faces.css";
import "../../design/tokens/tokens.css";
import "../../design/css/base.css";
import "../../design/css/components.css";
import "./app.css";
import "./analytics/analytics.css";

import { App } from "./App";
import { Sprites } from "./components/Sprites";
import { SessionProvider } from "./session";

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing #root");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <Sprites />
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
